import React from 'react';
import Tile from '../../Tile';
import SectionHeader from './SectionHeader';
import FlexContainer from '../../FlexContainer';
import line_of_sight from '../../../static/img/line_of_sight.jpg'
import pool_detection from '../../../static/img/pool_detection.jpg'

const Apps = () => (
  <>
    <SectionHeader heading="Featured Apps" />
    <FlexContainer>
      <Tile title="Line-of-Sight" bg={line_of_sight}>
        <p className="category">LocateAI</p>
      </Tile>
      <Tile title="Solar Panels" bg={pool_detection}>
        <p className="category">GeoAI</p>
      </Tile>
    </FlexContainer>
  </>
)

export default Apps;